// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import React, { Component, PropTypes } from 'react';
var _ = require('lodash');
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
//import {CSVLink, CSVDownload} from 'react-csv';
import {
  showLoader
} from '../../actions/actions';
// import { loadTwigs, changeDisplayOption } from '../../actions/locationView';
import constants from '../../Constants';

import Article from 'grommet/components/Article';
import Header from 'grommet/components/Header';

import Headline from 'grommet/components/Headline';
import Section from 'grommet/components/Section';
import Search from 'grommet/components/Search';
import Title from 'grommet/components/Title';
import Tile from 'grommet/components/Tile';
import Box from 'grommet/components/Box';
import FormField from 'grommet/components/FormField';
import DateTime from 'grommet/components/DateTime';
import Form from 'grommet/components/Form';
// import Label from 'grommet/components/Label';
import Value from 'grommet/components/Value';
import Select from 'grommet/components/Select';
import Button from 'grommet/components/Button';
import Split from 'grommet/components/Split';
import CheckBox from 'grommet/components/CheckBox';
import CaretBackIcon from 'grommet/components/icons/base/CaretBack';
import Heading from 'grommet/components/Heading';

import NavControl from '../NavControl';
// import  from 'grommet/components/Base';
// import Chart, { Layers, Base, Axis, Grid, Area, Bar, Line, Marker, MarkerLabel, HotSpots } from 'grommet/components/chart/Chart';


import { timeFormat } from "d3-time-format";
import { tsv } from "d3-request";
import { scaleTime } from "d3-scale";
import { format } from "d3-format";
//import { ChartCanvas, Chart, series, scale, coordinates, tooltip, axes, helper, indicator, annotation } from "react-stockcharts";
import { ChartCanvas, Chart, ZoomButtons } from "react-stockcharts";
//var { EdgeIndicator } = coordinates;

//var { BarSeries, LineSeries, AreaSeries, ScatterSeries, CircleMarker, SquareMarker, TriangleMarker } = series;
import { CandlestickSeries, BarSeries, LineSeries, AreaSeries } from "react-stockcharts/lib/series";

//var { discontinuousTimeScaleProvider } = scale;
import { discontinuousTimeScaleProvider } from "react-stockcharts/lib/scale";

//var { ema, sma } = indicator;
import { ema, sma } from "react-stockcharts/lib/indicator";

//var { CrossHairCursor, MouseCoordinateX, MouseCoordinateY } = coordinates;
import { EdgeIndicator, CrossHairCursor, CurrentCoordinate, MouseCoordinateX, MouseCoordinateY } from "react-stockcharts/lib/coordinates";

//var { Label } = annotation;
import { Label } from "react-stockcharts/lib/annotation"

//var { OHLCTooltip, HoverTooltip, MovingAverageTooltip } = tooltip;
import { OHLCTooltip, HoverTooltip, MovingAverageTooltip } from "react-stockcharts/lib/tooltip"

//var { XAxis, YAxis } = axes;
import {XAxis, YAxis } from "react-stockcharts/lib/axes"

//var { fitWidth } = helper;
import { fitWidth } from "react-stockcharts/lib/helper"

import { navEnable } from '../../actions/nav';

const chartOptions = {
  height: 200,
  width: 1000,
  margin: { left: 130, right: 100, top: 20, bottom: 30 },
  showGrid: false
}
var chartHeadingStyle = {
  fontWeight: 'bold',
  marginTop: '15px'
}
var chartSubMinMaxStyle = {
  fontWeight: 'initial',
}
var gridHeight = chartOptions.height - chartOptions.margin.top - chartOptions.margin.bottom;
var gridWidth = chartOptions.width - chartOptions.margin.left - chartOptions.margin.right;

var yGrid = chartOptions.showGrid ? {
  innerTickSize: -1 * gridWidth,
  tickStrokeDasharray: 'Solid',
  tickStrokeOpacity: 0.5,
  tickStroke: "#FFFFFF",
  tickStrokeWidth: 1
} : {};
var xGrid = chartOptions.showGrid ? {
  innerTickSize: -1 * gridHeight,
  tickStrokeDasharray: 'Solid',
  tickStrokeOpacity: 0.2,
  tickStrokeWidth: 1,
  showTicks: false
} : {};
var smaFunction = '';

var chartData = [];
// var sma20 = sma()
//   .windowSize(this.props.trendAverage)
//   .sourcePath("yValue")
//   .merge((d, c) => { d.sma20 = c })
//   .accessor(d => d.sma20)
//   .stroke("blue");

class LocationView extends Component {

  constructor(props) {
    super(props);

    // this._onStartDateChange = this._onStartDateChange.bind(this);
    this._onHoverChart = this._onHoverChart.bind(this);
    this.getLabelX = this.getLabelX.bind(this);
    this.getLabelY = this.getLabelY.bind(this);
    this._tickFormat = this._tickFormat.bind(this);
    // this._updateChart = this._updateChart.bind(this);
    // this._selectTwig = this._selectTwig.bind(this);

    // this.renderTwigCheckboxes = this.renderTwigCheckboxes.bind(this);
    this.renderCharts = this.renderCharts.bind(this);
    // this._changeDisplayOption = this._changeDisplayOption.bind(this);
    // this.props.dispatch(loadTwigs())
    // this._setDocumentTitle(props);
    this.state = {
      selectedTwigIndex: 0,
      cpuIndex: 0, memoryIndex: 0, storageIndex: 0
    };
  }

  componentWillMount() {
    // this.props.dispatch(navEnable(false));
  }

  componentWillReceiveProps(nextProps) {
    let trendAverage = Number(nextProps.trendAverage);

    smaFunction = sma()
      .options({ windowSize: trendAverage, sourcePath : "yValue" })
      .merge((d, c) => { d.smaFunction = c })
      .accessor(d => d.smaFunction)
      .stroke("blue");
  }


  componentDidMount() {
    let sectionElement = ReactDOM.findDOMNode(this.refs.sectionElement)
    if (sectionElement) {
      chartOptions.width = sectionElement.clientWidth - 50;
    }
  }
  componentWillUpdate() {
    let sectionElement = ReactDOM.findDOMNode(this.refs.sectionElement)
    if (sectionElement) {
      chartOptions.width = sectionElement.clientWidth - 50;
    }
  }


  componentWillUnmount() {
  }


  _onHoverChart(e) {
    // console.log('dateL--', e)
  }


  getLabelX() {
    return 100;
  }
  getLabelY() {
    return 10;
  }
  _getOrderedArr(obj) {
    let arr = [];

    let addToIndex = 0;
    Object.keys(obj).map((key, index) => {
      // debugger

      if (key.search('onboard') > -1) {
        arr[0] = [key, obj[key]];
        addToIndex = addToIndex + 1;
      }
      if (key.indexOf(constants.CHART_OPTIONS.TOP) !== -1) {
        arr[0 + addToIndex] = [constants.CHART_OPTIONS.TOP, obj[key]];
      } else if (key.indexOf(constants.CHART_OPTIONS.MIDDLE) !== -1) {
        arr[1 + addToIndex] = [constants.CHART_OPTIONS.MIDDLE, obj[key]];
      } else if (key.indexOf(constants.CHART_OPTIONS.BOTTOM) !== -1) {
        arr[2 + addToIndex] = [constants.CHART_OPTIONS.BOTTOM, obj[key]];
      }
      // let lastLetter = key.substr(key.length - 1, 1)
      // switch (lastLetter) {
      //   //case constants.CHART_OPTIONS.TOP
      //   case constants.CHART_OPTIONS.TOP:
      //     arr[0 + addToIndex] = [lastLetter, obj[key]];
      //     break;
      //   case constants.CHART_OPTIONS.MIDDLE:
      //     arr[1 + addToIndex] = [lastLetter, obj[key]];
      //     break;
      //   case constants.CHART_OPTIONS.BOTTOM:
      //     arr[2 + addToIndex] = [lastLetter, obj[key]];
      //     break;
      //   default:
      //     break
      // }
    });
    return arr;
  }

  // _pad(number) {
  //   if (number < 10) {
  //     return '0' + number;
  //   }
  //   return number;
  // }

  _getDateValue(date) {
    let MM = (date.getMonth() + 1) < 10 ? '0'+(date.getMonth() + 1) : (date.getMonth() + 1);
    let dd = (date.getDate() < 10) ? '0'+date.getDate() : date.getDate();
    let hh = (date.getHours() < 10) ? '0'+ date.getHours() : date.getHours();
    let mm = (date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes();

    return date.getFullYear().toString()+ '-' + MM + '-' + dd + ' ' + hh + ':' + mm;
    //return date.getFullYear().toString()+ '-' + this._pad(date.getMonth() + 1) + '-' + this._pad(date.getDate()) + ' ' + this._pad(date.getHours()) + ':' + this._pad(date.getMinutes());
    //return (date.getMonth() + 1) + '-' + date.getDate() + '-' + date.getFullYear().toString() + ' ' + date.getHours() + ':' + date.getMinutes();
  }
  _tooltipContent(calculators) {
    return ({ currentItem, xAccessor }) => {
      //console.log(this.props);
      var labels = [];
      if (this.props.showRawGraph)
        labels.push({ label: "Raw Value", value: currentItem.yValue.toFixed(4) });
      if (this.props.showTrendLine)
        labels.push({ label: "Trend Value", value: currentItem.smaFunction ? currentItem.smaFunction.toFixed(4) : '' })
      labels.push({ label: "Upper Limit", value: currentItem.topLine })
      labels.push({ label: "Lower Limit", value: currentItem.bottomLine })

      return {
        x: this._getDateValue(currentItem.xValue),
        y: labels
      };
    };
  }

  _displayXValue(a) {
    // console.log('aaaa---', a)
    // timeFormat("%d-%m-%y %h")
  }

  _tickFormat(e) {
    let date = chartData[e].xValue;
    return (date.getMonth() + 1) + '-' + date.getDate() + '-' + date.getFullYear().toString().substr(-2) + ' ' + date.getHours() + 'h';
  }


  renderCharts() {
    // console.log('chartData::', this.props.chartData);
    // this.props.dispatch(showLoader(true));
    const {
      nav: { responsive }
    } = this.props;
    try {
    let chartsArr = [];
    let chart = [];


    if (this.props.chartData && this.props.chartData != 'loading' && this.props.showChart) {
      let allObjects = Object.entries(this.props.selectedTwig.details.data);
      const filterObjects = allObjects.sort((a, b) => a[1].sort_order - b[1].sort_order);
      /*
        --> Display order of charts based on sort_order present inside selectedTwig.
        --> first sort array of selectedTwig details, then compare selectedTwig array to 
            chartsData array to make it the same order.
        --> finally remove "aw"(Available Water) present inside chartsData array.  
      */
      let allChartsData = Object.entries(this.props.chartData);
      const filterChartsData = allChartsData.sort((a, b) => filterObjects.findIndex(each => each[0] === a[0]) - filterObjects.findIndex(each => each[0] ===  b[0])).filter(eachChart => !eachChart[0].includes('aw') && !eachChart[0].includes('salinity'));
      filterChartsData.map((eachTwig, twigIndex) => {
        const twigKey = eachTwig[0];
        const twigItem = eachTwig[1];
        if (twigItem) {

          let chartArrInOrder = this._getOrderedArr(twigItem);

          chartArrInOrder.map((subArr, index) => {
            let key = subArr[0];
            chart = _.cloneDeep(subArr[1]);
            if (chart.length && chart.length > 0) {
              let highest = 0;
              let lowest = 10000;
              chart.forEach((d, i) => {
                if (d.yValue <= lowest) {
                  lowest = d.yValue;
                }
                if (d.yValue >= highest) {
                  highest = d.yValue;
                }
                // d.xValue = new Date(d.xValue);
                d.xValue = new Date(d.xValue);
              });
              chart.reverse();


              let sensor = this.props.selectedTwig.details.data[twigKey]
              let sensorName = this.props.selectedTwig.settings.sensorName;
              let maxValue = '';
              let minValue = '';
              let lineColor = '';
              let subTitile = '';
              if (key.search('onboard') > -1) {
                lineColor = '#a308e6'; // green
                subTitile = '';
              }
              if (sensor) {
                switch (key) {
                  case constants.CHART_OPTIONS.TOP:
                    lineColor = '#0be039'; // green
                    subTitile = sensorName && sensorName.value[0] ? '- '+sensorName.value[0]["1"] || '- Top' : '- ';
                    maxValue = sensor.multivalue_max ? sensor.multivalue_max.Top : sensor.max_value
                    minValue = sensor.multivalue_min ? sensor.multivalue_min.Top : sensor.min_value
                    break;
                  case constants.CHART_OPTIONS.MIDDLE:
                    lineColor = '#fce705'; //yellow
                    subTitile = sensorName && sensorName.value[1] ? '- '+sensorName.value[1]["2"] || '- Middle' : '- ';
                    maxValue = sensor.multivalue_max ? sensor.multivalue_max.Middle : sensor.max_value
                    minValue = sensor.multivalue_min ? sensor.multivalue_min.Middle : sensor.min_value
                    break;
                  case constants.CHART_OPTIONS.BOTTOM:
                    lineColor = '#fc0b07'; //red
                    subTitile = sensorName && sensorName.value[2] ? '- '+sensorName.value[2]["3"] || '- Bottom' : '- ';
                    maxValue = sensor.multivalue_max ? sensor.multivalue_max.Bottom : sensor.max_value
                    minValue = sensor.multivalue_min ? sensor.multivalue_min.Bottom : sensor.min_value
                    break;
                  default:
                    maxValue = sensor.max_value
                    minValue = sensor.min_value
                    break
                }
              } else
                return;




              // let maxValue = this.props.selectedTwig.details.data[twigKey].max_value != null ? this.props.selectedTwig.details.data[twigKey].max_value : false;
              // let minValue = this.props.selectedTwig.details.data[twigKey].min_value != null ? this.props.selectedTwig.details.data[twigKey].min_value : false;
              chart.forEach((d, i) => {
                d['topLine'] = maxValue;
                d['bottomLine'] = minValue;
              })
              chartData = _.cloneDeep(chart);

              //let highestValue = ((highest > maxValue) && (this.props.showUpperLimit)) ? highest + (highest * 20 / 100) : maxValue;

              // highestValue = highestValue + (highestValue * 15 / 100);

              //let lowestValue = ((lowest < minValue) && (this.props.showLowerLimit)) ? lowest - (lowest * 20 / 100) : minValue;
              let highestValue = highest + (highest * 5.0 / 100);
              let lowestValue = lowest - (lowest * 5.0 / 100);
              if(this.props.showUpperLimit && maxValue != null) {
                highestValue = (highest > maxValue) ? highestValue : maxValue;
              }
              if(this.props.showLowerLimit && minValue != null) {
                lowestValue = (lowest < minValue) ? lowestValue : minValue ;
              }
              //console.log('highest : ' + highestValue + ' lowest : ' + lowestValue );
              // let percentToleration = (lowestValue * 5 / 100);
              // percentToleration = percentToleration < 0 ? percentToleration * -1 : percentToleration;
              // lowestValue = lowestValue - (percentToleration)

              let yExtents = '';
              //{[d => [d.high, d.low], ema20.accessor(), ema50.accessor()]}
              if ((this.props.showUpperLimit && maxValue != null) || (this.props.showLowerLimit && minValue != null)) {
                yExtents = [Number(highestValue), Number(lowestValue)]
                // yExtents = [minValue, maxValue]
              } else {
                // yExtents = [highest, lowest]
                yExtents = d => [d.yValue, smaFunction.accessor()];
              }
              //  yExtents = {[d => [d.yValue, smaFunction.accessor()], highestValue, lowestValue]}
              // let lastLetter = key.substr(key.length - 1, 1)
              // if (key.search('onboard') > -1) {
              //   lineColor = '#a308e6'; // green
              //   subTitile = '';
              // }
              // switch (key) {
              //   case constants.CHART_OPTIONS.TOP:
              //     lineColor = '#0be039'; // green
              //     subTitile = '- Top';
              //     break;
              //   case constants.CHART_OPTIONS.MIDDLE:
              //     lineColor = '#fce705'; //yellow
              //     subTitile = '- Middle';
              //     break;
              //   case constants.CHART_OPTIONS.BOTTOM:
              //     lineColor = '#fc0b07'; //red
              //     subTitile = '- Bottom';
              //     break;
              //   default:
              //     break
              // }
              let xtentArr = [chart[0].xValue, chart[chart.length - 1].xValue]
              // let b = new Date(chart[0].xValue)
              // b.setMinutes(b.getMinutes() - 1);
              // xtentArr.push(b);

              /**** */

              /*** */
              let chartsType = [];
              var hoverSize = 95;
              if (this.props.showRawGraph && this.props.showTrendLine) {
                chartsType.push(<LineSeries
                  key={twigIndex + '_' + '001'}
                  yAccessor={d => d.yValue}
                  stroke={lineColor}
                  //interpolation={curveBasis}
                  strokeDasharray="Solid" />
                )
                chartsType.push(< LineSeries key={twigIndex + '_' + '002'} yAccessor={smaFunction.accessor()} stroke={smaFunction.stroke()} strokeDasharray="Solid"//interpolation={curveBasis}
                />);
              } else if (this.props.showTrendLine) {
                chartsType.push(< LineSeries key={twigIndex + '_' + '001'} yAccessor={smaFunction.accessor()} stroke={smaFunction.stroke()} strokeDasharray="Solid"//interpolation={curveBasis}
                />
                )

                hoverSize = 80;

              } else if (this.props.showRawGraph) {
                chartsType.push(<LineSeries key={twigIndex + '_' + '001'}
                  yAccessor={d => d.yValue}
                  stroke={lineColor}
                  // interpolation={curveBasis}
                  strokeDasharray="Solid" />
                )

                hoverSize = 80;
              }

              if (this.props.showUpperLimit && maxValue != null) {
                chartsType.push(<LineSeries
                  key={twigIndex + '_' + '003'}
                  yAccessor={d => d.topLine}
                  stroke="#040404"
                  strokeDasharray="Solid" />
                );
              }
              if (this.props.showLowerLimit && minValue != null) {
                chartsType.push(<LineSeries
                  key={twigIndex + '_' + '004'}
                  yAccessor={d => d.bottomLine}
                  stroke="#ff06ad"
                  strokeDasharray="Solid" />
                );
              }

              const headers =[
                  { label: "Time",
                    key: "xValue"
                  },
                  { label: "Value",
                    key: "yValue"
                  },
                  { label: "Maximum Threshold value",
                    key: "topLine"
                  },
                  { label: "Minimum Threshold value",
                    key: "bottomLine"
                  }
                ];

              //const { type, data: chart, width, ratio } = this.props;

              const calculatedData = smaFunction(chart);
              const xScaleProvider = discontinuousTimeScaleProvider
                .inputDateAccessor(d => d.xValue);
              const {
                data,
                xScale,
                xAccessor,
                displayXAccessor,
              } = xScaleProvider(calculatedData);

              chartsArr.push(
                [
                  <div style={chartHeadingStyle} key={twigIndex + '_' + '006'}>
                    {sensor.label + ' ' + subTitile + ' ' + '(' + sensor.Unit + ')'}
                    {/* <div className="download-graph-button">
                      <CSVLink data={chart} headers={headers}
                        filename={this.props.selectedTwig.twigId + ' ' + sensor.label + ' ' + subTitile + ' ' + '(' + sensor.Unit + ').csv'}>
                        Download CSV - {sensor.label + ' ' + subTitile + ' ' + '(' + sensor.Unit + ')'}
                      </CSVLink>
                    </div> */}
                    <div style={chartSubMinMaxStyle}>{'Upper Limit: ' + maxValue + ' Lower Limit: ' + minValue}</div>
                  </div>,

                  <ChartCanvas key={twigKey + '_' + index} ratio={0} width={chartOptions.width} height={chartOptions.height}
                    {...(responsive === 'multiple' ? {margin:chartOptions.margin} : undefined)}
                    type='svg'
                    plotFull={true}
                    pointsPerPxThreshold={5}
                    seriesName={twigKey + '_' + index}
                    data={chart}
                    xAccessor={d => d.xValue}
                    //xScaleProvider={discontinuousTimeScaleProvider}
                    xScale={scaleTime()}
                    calculator={[smaFunction]}
                  >
                    {/*tickValues={[0, 100,200,300,400,500,600,700,800,900,999]}
                        tickInterval={10}
                        tickFormat={this._tickFormat}*/}
                    {/*tickValues={[0, (chart.length - 1)]}

                     yExtents={d => [d.yValue, smaFunction.accessor()]}
                     yExtents= {d => [d.yValue, d.topLine,d.bottomLine]}
                      yExtents={yExtents}
                     */}
                    <Chart id={1} key={twigIndex + '_' + '007'}
                      yExtents={yExtents}
                    >

                      <XAxis axisAt="bottom"
                        orient="bottom"
                        showTicks={true}
                        ticks={5}
                        {...xGrid} key={twigIndex + '_' + '008'}/>
                      <YAxis
                        axisAt="left"
                        orient="left"
                        ticks={5}
                        {...yGrid}
                        key={twigIndex + '_' + '009'}/>

                      {chartsType}
                      <MouseCoordinateX
                        rectWidth={150}
                        at="bottom"
                        orient="bottom"
                        fill={"#455967"}
                        bgFill={"#455967"}
                        displayFormat={this._getDateValue} />

                      {/*<ZoomButtons/>*/}

                    </Chart>
                    <HoverTooltip
                      chartId={1}
                      bgheight={hoverSize}
                      bgwidth={160}
                      fill={"#455967"}
                      bgFill={"#455967"}
                      stroke={"white"}
                      fontFill={"white"}
                      tooltipContent={this._tooltipContent([])}
                      fontSize={15} />

                    <CrossHairCursor />
                  </ChartCanvas>,

                ]


              )
            };
            // }

          });
        }


      });
      // this.props.dispatch(showLoader(false));
      if (chartsArr.length > 0) {
        return chartsArr;
      } else {
        return <h2>No data</h2>;
      }
    } else if (this.props.chartData == 'loading') {
      return null;
    } else if (!this.props.showChart) {
      // this.props.dispatch(showLoader(false));
      return <h2>No data</h2>;
    } else {
      // this.props.dispatch(showLoader(false));
      return null;
    }
  } catch(e) {
    console.error(e);
  }

  }


  render() {
    if (this.props.zoom && document.getElementsByClassName('stemdetails-section')[0]) {
      chartOptions['height'] = screen.availHeight -
        document.getElementsByClassName('stemdetails-section')[0].clientHeight - 150
    } else
      chartOptions['height'] = 200
    return (
      <Section pad='small'
        justify='center'
        align='start'
        ref="sectionElement">

        {this.renderCharts()}

      </Section>

    );
  }

}

LocationView.propTypes = {
  twigsList: PropTypes.array,
  search: PropTypes.object
};

let select = (state, props) => ({
  twigsList: state.locationView.twigsList,
  selectedTwig: state.locationView.selectedTwig,
  chartData: state.locationView.chartData,
  resolution: state.locationView.resolution,
  showChart: state.locationView.showChart,
  showRawGraph: state.locationView.showRawGraph,
  showTrendLine: state.locationView.showTrendLine,
  trendAverage: state.locationView.trendAverage,
  showUpperLimit: state.locationView.showUpperLimit,
  showLowerLimit: state.locationView.showLowerLimit,
  zoom: state.locationView.zoom,
  chosenTwig:state.locationView.chosenTwig,
  nav: state.nav,
  // search: state.search
});

export default connect(select)(LocationView);



// WEBPACK FOOTER //
// ./src/js/components/location/ChartView.js